

























































































































































































































  import { Component, Mixins } from 'vue-property-decorator'
  import BaseVue from '@/mixins/BaseVue'
  import {
    Worklist,
    PromotionListFilter,
    EPromotionStatus,
    EDownloadPromotionType,
    SelectedCMMF,
StatusChangeUpdate,
CustomerDto
  } from '@/services/connecteur'
import { dateShortFormat } from '@/filters/dateFormat'
import serviceModule from '@/store/modules/ServiceModule'
import CancelDialog from '@/components/Dialogs/CancelDialog.vue'
import CloneDialog from '@/components/Dialogs/CloneDialog.vue'
import ImportPromotionDialog from '@/components/Dialogs/ImportPromotionDialog.vue'
import { DataRetourActionComponent } from '@/models/utils'
import codeFormat from '@/filters/cmmfCodeFormat'
import { PromotionOption } from '@/models/Enum'
import userModule from '@/store/modules/UserModule'
import salesOrgsModule from '@/store/modules/SalesOrgsModule'
import PromotionFilter from '@/components/Promotions/Filter/PromotionFilter.vue'
import PromotionModule from '@/store/modules/PromotionModule'

@Component({
  components: {
    CancelDialog,
    CloneDialog,
    ImportPromotionDialog,
    PromotionFilter
  },
  filters: {
    dateShortFormat,
    codeFormat
  }
})
export default class PromotionList extends Mixins(BaseVue) {
  public EDownloadPromotionType = EDownloadPromotionType
  public customerChoice: CustomerDto[] = []
  public showCancelDialog = false
  public showCloneDialog = false
  public showImportPromotionDialog = false
  public openDownloadFab = false
  public promotionList: Worklist[] = []
  public selectedWorkList: Worklist = new Worklist()
  public loading = true
  public headers: any[] = [
    {
      text: this.$t('promotions.fields.id'),
      value: 'id'
    },
    {
      text: this.$t('promotions.fields.promotionName'),
      value: 'promotionName',
      class: 'promotion-name-column'
    },
    {
      text: this.$t('promotions.fields.salesOrgs'),
      value: 'salesOrg.description'
    },
    {
      text: this.$t('promotions.fields.centralCustomer'),
      value: 'customer.name'
    },
    {
      text: this.$t('promotions.fields.keyAccountManager'),
      value: 'kam.fullName'
    },
    {
      text: this.$t('promotions.fields.creationDate'),
      value: 'creationDate'
    },
    {
      text: this.$t('promotions.fields.modificationDate'),
      value: 'modificationDate'
    },
    { text: this.$t('promotions.fields.status'), value: 'status.name' },
    { text: this.$t('promotions.fields.sellInWindow'), value: 'sellInStart' },
    {
      text: this.$t('promotions.fields.sellOutWindow'),
      value: 'sellOutStart'
    },
    { text: this.$t('promotions.actions'), align: 'center', value: 'actions' }
  ]

  public mounted () {
    const option = this.$route.params.option
    if (option) {
      const enumValues = Object.values(PromotionOption) as string[]
      const index = enumValues.indexOf(option)
      if (index === -1) {
        this.redirectToOption(PromotionOption.Worklist)
      } else {
        this.filter.listOption = index
      }
    } else {
      this.filter.listOption = 0
      this.redirectToOption(PromotionOption.Worklist)
    }

    if (userModule.userIsReportingUser) {
      this.filter.listOption = 2
    }
    this.fetchData()
  }

  public redirectToOption (option: number | PromotionOption) {
    let valueOption: PromotionOption
    try {
      if (typeof option === 'number') {
        valueOption = Object.values(PromotionOption)[option]
      } else {
        valueOption = option
      }
    } catch (error) {
      valueOption = PromotionOption.Mine
    }

    this.$router.replace({
      name: 'allPromotion',
      params: {
        option: valueOption
      }
    })
  }

  public get filter (): PromotionListFilter {
    return PromotionModule.filter
  }

  public get canCreate () {
    return !userModule.userIsDemandPlanner &&
      !userModule.userIsSNP &&
      !userModule.userIsReportingUser
  }

  public get canImportPromotion () {
    return userModule.userIsITLocal || userModule.userIsAdmin
  }

  public canCopy (salesOrgId: number) {
    return userModule.isUserKamInSalesOrg(salesOrgId)
  }

  public canDownload (salesOrgId: number) {
    return userModule.isUserKamInSalesOrg(salesOrgId)
  }

  public setCopyItem (workList: Worklist) {
    this.selectedWorkList = workList
    this.showCloneDialog = true
  }

  public copy () {
    serviceModule.promotionApi
      .clonePromotion(this.selectedWorkList.id as number)
      .then(res => {
        this.$router.push('/promotion/' + res)
      })
      .catch(err => {
        this.displayError(err)
      })
  }

  public downloadPromotions (type: EDownloadPromotionType) {
    const listId = this.promotionList.map(x => x.id) as number[]
    const filename =
      type === EDownloadPromotionType.BU ? 'BU overview.xlsx' : 'promotion.xlsx'
    serviceModule.promotionApi
      .getExcelPromotions(type, listId)
      .then(response => {
        const fileURL = window.URL.createObjectURL(new Blob([response.data]))
        const fileLink = document.createElement('a')
        fileLink.href = fileURL
        fileLink.setAttribute('download', filename)
        document.body.appendChild(fileLink)
        fileLink.click()
      })
      .catch(err => {
        this.displayError(err)
      })
  }

  public download (id: number) {
    serviceModule.promotionApi
      .getExcelPromotions(EDownloadPromotionType.NORMAL, [id])
      .then(response => {
        const fileURL = window.URL.createObjectURL(new Blob([response.data]))
        const fileLink = document.createElement('a')
        fileLink.href = fileURL
        fileLink.setAttribute(
          'download',
          response.fileName ? response.fileName : 'promotion.xlsx'
        )
        document.body.appendChild(fileLink)
        fileLink.click()
      })
      .catch(err => {
        this.displayError(err)
      })
  }

  public async fetchData (changeOption?: number | undefined) {
    if (typeof changeOption === 'number') {
      this.redirectToOption(changeOption)
    }

    try {
      this.loading = true
      this.promotionList = await serviceModule.promotionApi.getPromotionWithFilter(
        this.filter
      )

      this.customerChoice = this.promotionList.filter((value, index, self) =>
        index === self.findIndex((promotion) => (
          promotion.customer != null && promotion.customer?.id === value.customer?.id
        ))
      )
      .map((promotion) => promotion.customer) as CustomerDto[]

      this.loading = false
    } catch (error) {
      this.displayError(error)
    }
  }

  public get canUserCancelPromotions () {
    return userModule.userIsKAM || userModule.userIsAdmin
  }

  public canCancelPromotion (promo: Worklist) {
    const userHaveRight =
      (userModule.userIsKAM && userModule.id === promo.kam?.id) ||
      userModule.userIsAdmin
    let isStatusUndonnable = false
    if (promo.status?.id) {
      isStatusUndonnable =
        promo.status.id === EPromotionStatus.NEW ||
        promo.status.id === EPromotionStatus.REWORK ||
        promo.status.id === EPromotionStatus.CHANGED ||
        promo.status.id === EPromotionStatus.DRAFT ||
        promo.status.id === EPromotionStatus.PREVALIDATED ||
        promo.status.id === EPromotionStatus.APPROVED
    }

    return isStatusUndonnable && userHaveRight
  }

  public cancelPromotion (workList: Worklist) {
    this.selectedWorkList = workList
    this.showCancelDialog = true
  }

  public sendTo (data: DataRetourActionComponent, id: number) {
    if (data) {
      serviceModule.promotionApi
        .setStatus(new StatusChangeUpdate({
          idPromotion: id,
          newStatus: data.newStatus,
          cancelReasonId: data.reason
        }))
        .then(() => {
          this.displayMessage(this.$t('promotion.sendTo').toString())
          this.fetchData()
        })
        .catch(err => {
          this.displayError(err)
        })
    }
  }

  public cancelMessage (workList: Worklist) {
    if (workList.status?.id === EPromotionStatus.CANCELLED) {
      return this.$t('promotions.sendToCancelledApo')
    } else {
      return this.$t('promotions.sendToCancelled')
    }
  }

  public confirmCancel (data: DataRetourActionComponent) {
    this.showCancelDialog = false
    this.sendTo(data, this.selectedWorkList.id as number)
  }

  public getListCMMF (item: Worklist): SelectedCMMF[] {
    if (item.listOfSelectedCMMF) {
      return item.listOfSelectedCMMF
    }
    return []
  }

    public get perPageOptions () {
      return JSON.parse(`${process.env.VUE_APP_PER_PAGE_OPTIONS}`)
    }
  }
